import Tag from '@commons/components/Tag';
import type { DrupalTerm } from '@commons/types/drupal';

/**
 * AiiA InsightTopic Term component.
 *
 * Renders topic tags as plain labels instead of links.
 */

const InsightTopicTerm = ({ name }: DrupalTerm) => (
  <Tag variant="tertiary" disableHover>
    {name}
  </Tag>
);

export default InsightTopicTerm;
